import { useData } from "../../../../entities/service/model/DataContext";
import { SmallService } from "../../../../entities/service/ui/SmallService/SmallService";
import "./LeftCatalog.css";


export const LeftCatalog = () => {

    const { products } = useData();
    return (
        <div className="left-catalog">
            {products.map((service) => (
                <SmallService key={service.id} service={service} />
            ))}
        </div>
    )
}